import { defineComponent as _defineComponent } from 'vue'
import { isImpersonate } from '@/modules/common/services/partner';
import { WealthPortfolioTabs } from '@/modules/wealth/views/WealthPortfolioV2/types';
import { computed, inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { IWithdrawSummary } from '@/modules/transaction/services/withdraw-by-portfolio';
import {
  ButtonPrimary,
  ConclusionStep,
  ListDisplay,
  MessageFoundation
} from '@warrenbrasil/nebraska-web';

import { PortfolioCategories } from '@/types/models/Portfolio';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConclusionStep',
  setup(__props) {

const infoCompletedWithdraw = inject('withdrawReview') as Ref<IWithdrawSummary>;

const route = useRoute();
const router = useRouter();

const portfolioId = computed(() => {
  return route.params.id as string;
});

const withdrawTitle = computed(() =>
  isImpersonate() ? 'Sugestão de resgate enviada' : 'Resgate solicitado'
);

function handleNextClick() {
  router.push({
    name: 'wealthPortfolio',
    params: {
      id: portfolioId.value,
      type: PortfolioCategories.WarrenManagement
    },
    query: {
      tab: WealthPortfolioTabs.Orders
    }
  });
}

return { __sfc: true,infoCompletedWithdraw, route, router, portfolioId, withdrawTitle, handleNextClick, ButtonPrimary, ConclusionStep, ListDisplay, MessageFoundation }
}

})